import { render, staticRenderFns } from "./model-personalDetails.vue?vue&type=template&id=184b5fe4&scoped=true&"
import script from "./model-personalDetails.vue?vue&type=script&lang=js&"
export * from "./model-personalDetails.vue?vue&type=script&lang=js&"
import style0 from "./model-personalDetails.vue?vue&type=style&index=0&id=184b5fe4&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "184b5fe4",
  null
  
)

export default component.exports